import React from 'react';
import AgentRunsPanel from './AgentRunsPanel';

interface Props {
  onOpenAgentChat?: (ticketKey: string) => void;
}

/** Agents page — replaces legacy Jobs list. */
const Agents: React.FC<Props> = ({ onOpenAgentChat }) => {
  return (
    <div className="h-full overflow-auto p-6">
      <AgentRunsPanel onOpenConversation={onOpenAgentChat} />
    </div>
  );
};

export default Agents;
